export const buyUpPageConstants = {
    labelForBuyUpTable: "Buy Up Coverage Options: Any plan listed below, if selected, will be added to your existing coverage.",
    labelForNoPlans: "Based on your previous benefit election, this selected amount exceeds the maximum coverage limit, therefore, you are not eligible for this additional amount this time"
}